<template>
  <div>
    <gc-order-list-with-acitons
      :orderList="orderList"
      :show-product-contract-no="false"
      @goToOrderDetail="toDetailInfo" @downloadOrderText="handleDownloadOrderText">
      <template #itemButton="order">
        <div v-if="showCancelButton(order)" class="return-btn research-font-color" @click="$emit('cancelOrder', order)">取消订单</div>
        <div v-if="showSubmitOrderButton(order)" style="margin-left: 10px;" class="pay-btn research-background-color" @click="$emit('submitOrder', order)">提交订单</div>
        <div v-if="showSubmitToSignOrderButton(order)" style="margin-left: 10px;" class="pay-btn research-background-color" @click="$emit('submitOrderToSign', order)">签署合同
        </div>
      </template>
    </gc-order-list-with-acitons>
  </div>
</template>

<script>
import EMKT from '@/emkt.js'
import GcOrderListWithAcitons from '../../../emktcommon/orders/order/GcOrderListWithActions.vue'
import { mapGetters } from 'vuex'
// import $ from 'jquery'
export default {
  components: { GcOrderListWithAcitons },
  props: {
    orderList: Array
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters(['customerNo'])
  },
  methods: {
    getOrderStatusText: EMKT.getOrderStatusText,
    handleDownloadOrderText (orderDetail) {
      EMKT.wxDownloadOrderText(orderDetail)
    },
    toDetailInfo: function (order) {
      EMKT.setStoreItem('leaveOrderListPosition', document.getElementById('myOrderList').scrollTop)
      console.log('订单信息', order, 'leaveOrderListPosition', document.getElementById('myOrderList').scrollTop)
      this.$router.push({ name: 'WeappMyOrderDetail', params: { orderNo: order.orderNo } })
    },
    showButton (order) {
      if (order.fromEmkt) {
        return this.showCancelButton(order) || this.showSubmitOrderButton(order)
      } else {
        return false
      }
    },
    showCancelButton (order) {
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      // return false
      let statusText = this.getOrderStatusText(order)
      // alert(statusText !== '执行中' || statusText !== '已完成' || statusText !== '已取消' || statusText !== '审核不通过')
      return statusText !== '已完成' && statusText !== '已取消' && statusText !== '审核不通过'
    },
    showSubmitOrderButton (order) {
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      let statusText = this.getOrderStatusText(order)
      return statusText === '待提交'
    },
    showSubmitToCheckSignApproveButton (order) {
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      let statusText = this.getOrderStatusText(order)
      return statusText === '待重新提交'
    },
    showSubmitToSignOrderButton (order) {
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      let statusText = this.getOrderStatusText(order)
      return statusText === '待签署'
    }
  }
}
</script>

<style scoped>
.pay-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 23px;
  color: #fff;
  text-align: center;
  font-size: 12px;
}

row {
  position: relative;
  margin-top: 2.4vw;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}


.return-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 21px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
}

</style>



// WEBPACK FOOTER //
// OrderListPage.vue?87c687a0